import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
  showBadges?: boolean;
}
export function Button({
  children,
  className = '',
  href,
  showBadges = false,
  ...props
}: ButtonProps) {
  const baseClasses = 'relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-200 bg-brand-green border border-transparent rounded-full hover:bg-brand-light focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-light focus:ring-offset-brand-dark shadow-[0_0_20px_rgba(34,197,94,0.3)] hover:shadow-[0_0_30px_rgba(34,197,94,0.5)]';
  const content = <motion.div whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className="w-full" data-id="element-53" data-mp="23at6vl4ydyn9">
      {href ? <a href={href} className={`${`${`${`${`${`${baseClasses} w-full text-center ${className}`} text-[18px]`} text-[16px]`} text-[16px]`} text-[16px] font-[700] font-sans`} mb-[0px]`} data-id="element-54" data-mp="2vypbdc0rkuul">
          {children}
        </a> : <button className={`${baseClasses} w-full ${className}`} {...props} data-id="element-55" data-mp="3bng71cztp7k">
          {children}
        </button>}
      {showBadges && <div className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] text-gray-400 md:text-xs" data-id="element-56" data-mp="89fk6tqwx1s4">
          <span className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-57" data-mp="3qig4ip0c5l75">
            <span className="inline-block h-2.5 w-2.5 shrink-0 rounded-full bg-green-500" data-id="element-58" data-mp="3uiq85v0nnziu" />
            Garantía 21 días
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-59" data-mp="3gkiim85y80hp">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-3.5 w-3.5 shrink-0" data-id="element-60" data-mp="3lhsbjxsjquaa">
              <rect width="18" height="11" x="3" y="11" rx="2" ry="2" data-id="element-61" data-mp="1i6dq5vfrpj2d" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-62" data-mp="1d8c554ys79o9" />
            </svg>
            Pago seguro
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-63" data-mp="18aspc0mfqou7">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-3.5 w-3.5 shrink-0" data-id="element-64" data-mp="13cr87l8kkzld">
              <path d="m11 17 2 2a1 1 0 1 0 3-3" data-id="element-65" data-mp="1r7bukeu4bslh" />
              <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" data-id="element-66" data-mp="1mb3ijab7wfij" />
              <path d="m21 3 1 11h-2" data-id="element-67" data-mp="2eyzg0h8m2bgd" />
              <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" data-id="element-68" data-mp="2exxzvycqmyrs" />
              <path d="M3 4h8" data-id="element-69" data-mp="2n7n1973jt7mn" />
            </svg>
            Mercado Pago
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-70" data-mp="2n9zre7jgmoas">
            <span aria-hidden="true" className="text-sm leading-none" data-id="element-71" data-mp="2r9icb3ba6zdm">
              📩
            </span>
            Acceso inmediato por email
          </span>
        </div>}
    </motion.div>;
  return content;
}